module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "AssetProvisioningIcon_White.4841ef01.png";